// src/features/stock/components/StockSubsectionPlaceholder.jsx
import { Stack } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import { getStockSubsectionByPath } from "../constants/stockAreas";
import StockPageHeader from "./StockPageHeader";

export default function StockSubsectionPlaceholder({
  sectionPath,
  subsectionPath,
}) {
  const navigate = useNavigate();
  const { section, subsection } = getStockSubsectionByPath(
    sectionPath,
    subsectionPath
  );

  if (!section) return <Navigate to="/stock" replace />;
  if (!subsection) return <Navigate to={`/stock/${section.path}`} replace />;

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <StockPageHeader
        title={subsection.label}
        onBack={() => navigate(`/stock/${section.path}`)}
      />
    </Stack>
  );
}
